import { createElement } from 'react';
import { string, node, bool } from 'prop-types';
import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import ConditionalWrap from 'conditional-wrap';
import _Table from './styled.js';
import TableBody from './TableBody.js';
export { default as TableBody, tableBodyDefaultProps, tableBodyPropTypes } from './TableBody.js';
import TableCaption from './TableCaption.js';
export { default as TableCaption, tableCaptionDefaultProps, tableCaptionPropTypes } from './TableCaption.js';
import TableCell from './TableCell.js';
export { default as TableCell, tableCellDefaultProps, tableCellPropTypes } from './TableCell.js';
import TableFoot from './TableFoot.js';
export { default as TableFoot, tableFootDefaultProps, tableFootPropTypes } from './TableFoot.js';
import TableHead from './TableHead.js';
export { default as TableHead, tableHeadDefaultProps, tableHeadPropTypes } from './TableHead.js';
import TableHeadCell from './TableHeadCell.js';
export { default as TableHeadCell, tableHeadCellDefaultProps, tableHeadCellPropTypes } from './TableHeadCell.js';
import TableRow from './TableRow.js';
export { default as TableRow, tableRowPropTypes } from './TableRow.js';
var OuterBorder = styled(Box).withConfig({
  displayName: "Table__OuterBorder",
  componentId: "sc-1as57q1-0"
})(["border:1px solid ", ";border-radius:5px;padding:0.25rem 0.5rem;", ";"], theme('fannypack.Table.borderColor'), function (props) {
  return props.isResponsive && css(["@media screen and (max-width:", "px){padding:0px;}"], function (props) {
    return theme("fannypack.layout." + props.responsiveBreakpoint + "Breakpoint");
  });
});

var Table = function Table(_ref) {
  var a11yTitle = _ref.a11yTitle,
      children = _ref.children,
      hasBorder = _ref.hasBorder,
      isResponsive = _ref.isResponsive,
      responsiveBreakpoint = _ref.responsiveBreakpoint,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yTitle", "children", "hasBorder", "isResponsive", "responsiveBreakpoint"]);

  return createElement(ConditionalWrap, {
    condition: hasBorder,
    wrap: function wrap(children) {
      return createElement(OuterBorder, {
        isResponsive: isResponsive,
        responsiveBreakpoint: responsiveBreakpoint
      }, children);
    }
  }, createElement(_Table, _extends({
    use: "table",
    "aria-label": a11yTitle,
    isResponsive: isResponsive,
    responsiveBreakpoint: responsiveBreakpoint
  }, props), children));
};

Table.Body = TableBody;
Table.Caption = TableCaption;
Table.Cell = TableCell;
Table.Foot = TableFoot;
Table.Head = TableHead;
Table.HeadCell = TableHeadCell;
Table.Row = TableRow;
var tablePropTypes = {
  a11yTitle: string,
  children: node.isRequired,
  hasBorder: bool,
  isHoverable: bool,
  isResponsive: bool,
  isStriped: bool,
  isVerticallyCentered: bool,
  responsiveBreakpoint: string
};
Table.propTypes = tablePropTypes;
var tableDefaultProps = {
  a11yTitle: undefined,
  hasBorder: false,
  isHoverable: false,
  isResponsive: false,
  isStriped: false,
  isVerticallyCentered: false,
  responsiveBreakpoint: 'mobile'
};
Table.defaultProps = tableDefaultProps;
var C = Table;
export default C;
export { C as Table, tableDefaultProps, tablePropTypes };